import { IButton } from 'app/interfaces/button/button.interface';
import ImagePath from 'app/utilities/imagePath';
import React from 'react';
import './Button.scss';

const Button = function init(props: IButton): React.ReactElement {
    const { buttonText, disabled, loading } = props;
    return (
        <button type="submit" disabled={disabled} className="btn btn-primary">
			{
				loading &&
				(
					<div className="loader-wrapper">
						<img className="loader" src={ImagePath.loaderGif.src} alt={ImagePath.loaderGif.alt} />
					</div>
				)
			}
            { buttonText }
        </button>
    );
};

export default Button;
